
import { Handle, Position } from 'reactflow';
import images from "./images";

function ObjectStoreNode({ data }) {
    const { nodeId, type } = data
    return (
        <>
            {/* <label>Storage {nodeId}</label> */}
            <div className="tank">
                <div className="bottom"></div>
                <div className="middle">
                    {type == "S3" &&
                        <div className="aws-store"
                        >
                            AWS S3
                            <img
                                src={images.S3Logo}
                                height="30px"
                                style={{ marginLeft: 20, marginTop: 2 }}
                            />
                        </div>
                    }
                    {type == "AZURE" &&
                        <div className="azure-store"
                        >
                            Azure Blob
                            <img
                                src={images.AzureBlobStore}
                                height="30px"
                                style={{ marginLeft: 20, marginTop: 2 }}
                            />
                        </div>
                    }
                    {type == "GCS" &&
                        <div className="GCS-store"
                        >
                            Google Cloud Storage
                            <img
                                src={images.GoogleObjStore}
                                height="30px"
                                style={{ marginLeft: 35, }}
                            />
                        </div>
                    }
                    {type == "minio" &&
                        <div className="minio-store"
                        >
                            Minio
                            <img
                                src={images.MinioLogo}
                                height="40px"
                                style={{ marginLeft: 10, marginTop: 2 }}
                            />
                        </div>
                    }
                    <Handle
                        className="sourceHandle"
                        position={Position.Left}
                        type="target"
                        style={{
                            top: 80
                        }}
                    />
                    <Handle
                        className="targetHandle"
                        position={Position.Right}
                        type="source"
                        style={{
                            left: 112,
                            top: 80
                        }}
                    />I
                </div>
                <div className="top"></div>
            </div>
        </>
    );
}

export default ObjectStoreNode;